import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GrupoListarComponent } from './grupo-listar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: GrupoListarComponent }    
    ])],
    exports: [RouterModule]
})
export class GrupoListarRoutingModule { }
